import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledGeneralFormBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  boxShadow: '10px 10px 50px rgba(1,2,10,0.3)',
  maxWidth: '100%',
  overflowX: 'auto',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.formTables,
  minHeight: { xs: '40em', md: '50em' },
  '*::-webkit-scrollbar': {
    width: '8px',
    height: '8px',
  },
  '*::-webkit-scrollbar-track': {
    background: 'inherit',
    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
  },
  '*::-webkit-scrollbar-thumb': {
    backgroundColor: 'gray',
    borderRadius: '20px',
  },
  '*::-webkit-scrollbar-corner': {
    background: 'inherit',
  },
}));

const GeneralFormBox = ({ children, sx = {}, ...props }) => {
  return (
    <StyledGeneralFormBox sx={sx} {...props}>
      {children}
    </StyledGeneralFormBox>
  );
};

export default GeneralFormBox;